import React, { useState, useEffect } from 'react';
import {
  Routes,
  Route,
} from 'react-router-dom';
import { Menu } from './components/menu/Menu';
import { Header } from './components/header/Header';
import { Nav } from './components/nav/Nav';
import { Main } from './components/Main';
import { Pivot } from './components/Pivot';
import './App.css';

const App = () => {
  const [showPopup, setShowPopup] = useState(false);
  const [checkedStorage, setCheckedStorage] = useState(false);
  const [hasSubmitted, setHasSubmitted] = useState(localStorage.getItem('emailCaptured'));

  useEffect(() => {
    if (!hasSubmitted) {
      setShowPopup(true);
    } else {
      setShowPopup(false);
    }
  
    setCheckedStorage(true);
  }, [hasSubmitted]);

  return (
    <div className="App">
      <Menu />
      <Header />
      {checkedStorage && !showPopup && (
        <Nav />
      )}
      <Routes>
        <Route
          path="analysis"
          element={
            <Pivot checkedStorage={checkedStorage} showPopup={showPopup} setHasSubmitted={setHasSubmitted} />
          }
        />
        <Route
          path="/"
          element={
            <Main  checkedStorage={checkedStorage} showPopup={showPopup} setHasSubmitted={setHasSubmitted} />
          }
        />
      </Routes>
    </div>
  );
}

export default App;
